import qs from 'qs';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  loginHostUrl
} from '../../modules/ajio-fetch/utils';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import { accountCheck } from './signinAction';
import properties from '../../modules/ajio-util/properties';
import { requestType } from '../../constants/constant.js';

const login_url = properties.getProperty('loginPageURL');

function setSignUpOtpResponse(info) {
  return {
    type: 'SIGNUP_OTP_CREATED',
    statusCode: info.statusCode,
    message: info.message
  };
}

function setSignUpAuthResponse(info) {
  return {
    type: 'SIGNUP_AUTH_SUCCESS',
    authSuccess: info.statusCode,
    otpStatusMessage: info.message
  };
}

export function postSignUp(postSignUpInfo) {
  return {
    type: 'POST_SIGNUP',
    postSignUpInfo
  };
}

function hideError(dispatch) {
  let timeout = setTimeout(() => {
    dispatch(setErrorObject({}));
    clearTimeout(timeout);
  }, 5000);
}

export function signupSendOTP(data, callback) {
  return function(dispatch) {
    data = { ...data, requestType: requestType.SENDOTP };
    dispatch(showLoader('auth-modal-loader'));
    const apiEndPoint = loginHostUrl(login_url, '/api/auth/signupSendOTP');
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        dispatch(setSignUpOtpResponse(serviceRes));
        dispatch(hideLoader('auth-modal-loader'));
        callback({ ...serviceRes });
        return Promise.resolve(serviceRes);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        return errorParser(error, statusCode).then((errorObj = {}) => {
          errorObj.originator = 'login';
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('auth-modal-loader'));
          hideError(dispatch);
          return Promise.reject(errorObj);
        });
      });
  };
}

export function signupAuthUser(data, callback) {
  return function(dispatch) {
    data = { ...data, requestType: requestType.AUTHUSER };
    dispatch(showLoader('auth-modal-loader'));
    const apiEndPoint = loginHostUrl(login_url, '/api/auth/signupAuthUser');
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(serviceRes => {
        if (serviceRes.hasOwnProperty('message')) {
          let errorObj = { statusCode: 400, message: serviceRes.message };
          dispatch(setErrorObject(errorObj));
        } else {
          dispatch(setErrorObject({}));
        }
        dispatch(setSignUpAuthResponse(serviceRes));
        dispatch(hideLoader('auth-modal-loader'));
        callback({ ...serviceRes });
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          errorObj.originator = 'login';
          dispatch(hideLoader('auth-modal-loader'));
          dispatch(
            setErrorObject({ statusCode: errorObj?.statusCode, message: errorObj?.message })
          );
          callback({ ...errorObj });
        });
      });
  };
}
